import React from 'react'

function PPTFileIcon() {
  return (
    <svg
      width='50'
      height='66'
      viewBox='0 0 50 66'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M50 22H0V44H50V22Z'
        fill='#ED6C47'
      />
      <path
        d='M50 44H0V58C0 62.4183 3.58172 66 8 66H42C46.4183 66 50 62.4183 50 58V44Z'
        fill='#D35230'
      />
      <path
        d='M42 0H8C3.58172 0 0 3.58172 0 8V22H50V8C50 3.58172 46.4183 0 42 0Z'
        fill='#FF8F6B'
      />
      <path
        d='M37 20.1875H15.125C13.3991 20.1875 12 21.5866 12 23.3125V45.1875C12 46.9134 13.3991 48.3125 15.125 48.3125H37C38.7259 48.3125 40.125 46.9134 40.125 45.1875V23.3125C40.125 21.5866 38.7259 20.1875 37 20.1875Z'
        fill='black'
        fillOpacity='0.51'
      />
      <path
        d='M34 17H12.125C10.3991 17 9 18.3991 9 20.125V42C9 43.7259 10.3991 45.125 12.125 45.125H34C35.7259 45.125 37.125 43.7259 37.125 42V20.125C37.125 18.3991 35.7259 17 34 17Z'
        fill='#C6411F'
      />
      <path
        d='M23.0232 24.3082C24.411 24.2148 25.7867 24.6173 26.9054 25.4439C27.3653 25.8533 27.7259 26.3622 27.9598 26.9318C28.1938 27.5014 28.2948 28.1169 28.2554 28.7314C28.271 29.597 28.04 30.4493 27.5893 31.1885C27.1333 31.916 26.4766 32.4958 25.6982 32.8582C24.8089 33.2706 23.8372 33.4746 22.8572 33.4546H20.1554V38.4546H17.3947V24.3082H23.0232ZM20.1536 31.2939H22.5304C23.284 31.3482 24.0314 31.1253 24.6322 30.6671C24.8778 30.4328 25.0691 30.1475 25.1925 29.8312C25.3159 29.515 25.3685 29.1755 25.3464 28.8367C25.3464 27.2784 24.4387 26.4986 22.6232 26.4974H20.1536V31.2939Z'
        fill='white'
      />
    </svg>
  )
}

export default PPTFileIcon
